/**
 * Exceldownload working with NSWOW2 Tables
 */
class XTableNamer {
	constructor() {

		const elements = Array.prototype.slice.call(document.querySelectorAll('.content .ns-table-wrap, .content .ns-title-h1, .content .ns-title-h2, .content .ns-title-h3, .content .ns-title-h4, .content .ns-title-h5, .content .ns-title-h6, .content .ns-title-h3--accordion, .content .ns-title-h3__title, .content .accordion__title'));

		let h1;
		let h2;
		let h3;
		let h4;
		let h5;
		let h6;
		let c;
		const pageTitle = document.querySelector('.header__top-title');

		elements.forEach(element => {
			const className = element.classList[0];

			switch(className) {
				case "ns-title-h1":
					h1 = element.innerText;
					h2 = h3 = h4 = h5 = h6 = null; // Reset lower headings
					c = 0;
					break;
				case "ns-title-h2":
					if(!!element.innerText.trim()){
						h2 = element.innerText;
						h3 = h4 = h5 = h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "ns-title-h3":
					if(!!element.innerText.trim()){
						h3 = element.innerText;
						h4 = h5 = h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "ns-title-h4":
					if(!!element.innerText.trim()){
						h4 = element.innerText;
						h5 = h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "ns-title-h5":
					if(!!element.innerText.trim()){
						h5 = element.innerText;
						h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "ns-title-h6":
					if(!!element.innerText.trim()){
						h6 = element.innerText;
						c = 0;
					}
					break;
				case "ns-title-h3--accordion":
					const accordionTitle = element.querySelector('span:last-child');
					if(!!accordionTitle && !!accordionTitle.innerText.trim()){
						h3 = accordionTitle.innerText;  // Assign h3 for accordion title
						h4 = h5 = h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "ns-title-h3__title":
					if(!!element.innerText.trim()){
						h3 = element.innerText;  // Assign h3 for this specific title
						h4 = h5 = h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "accordion__title":
					const spanL = element.querySelector('span:last-child');
					if(!!spanL && !!spanL.innerText.trim()){
						h2 = spanL.innerText;  // Assign h2 for accordion title
						h3 = h4 = h5 = h6 = null; // Reset lower headings
						c = 0;
					}
					break;
				case "ns-table-wrap":
					let title = '';
					let fileTitle = '';
					if(!!pageTitle){
						title += pageTitle.innerText;
					}
					if(!!h1){
						if(!!pageTitle){
							title += ' – ';
						}
						title += h1.trim();
					}
					if(!!h2){
						if(!!h1 || !!pageTitle){
							title += ' – ';
						}
						title += h2.trim();
					}
					if(!!h3){
						if(!!h2 || !!h1 || !!pageTitle){
							title += ' – ';
						}
						title += h3.trim();
					}
					if(!!h4){
						if(!!h3 || !!h2 || !!h1 || !!pageTitle){
							title += ' – ';
						}
						title += h4.trim();
					}
					if(!!h5){
						if(!!h4 || !!h3 || !!h2 || !!h1 || !!pageTitle){
							title += ' – ';
						}
						title += h5.trim();
					}
					if(!!h6){
						if(!!h5 || !!h4 || !!h3 || !!h2 || !!h1 || !!pageTitle){
							title += ' – ';
						}
						title += h6.trim();
					}

					// Construct file title
					fileTitle = `${h6 || h5 || h4 || h3 || h2 || h1}`.trim().replace(/\s/g, '_');

					if(c > 0){
						title += ' ' + (c + 1);
						fileTitle += '_'+(c + 1);
					}
					element.dataset.xTitle = title;
					element.dataset.xFileTitle = fileTitle;
					c++;
					break;
			}
		});
	}
}
export default XTableNamer;
